import { render } from "./ModalUpdateSucursal.vue?vue&type=template&id=623f91e2"
import script from "./ModalUpdateSucursal.vue?vue&type=script&lang=js"
export * from "./ModalUpdateSucursal.vue?vue&type=script&lang=js"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__